import {ChangeDetectionStrategy, Component, EffectRef, InputSignal, OutputEmitterRef, Signal, WritableSignal, computed, effect, inject, input, output, signal} from '@angular/core';
import {DialogModule} from "@syncfusion/ej2-angular-popups";
import {ContentComponent} from "../content/content.component";
import {FormButtonComponent} from "../form-button/form-button.component";
import {HeadlineComponent} from "../headline/headline.component";
import {TooltipComponent} from "../tooltip/tooltip.component";
import {TranslatePipe} from "../../pipes/translate.pipe";
import {DialogService} from "../../services/dialog.service";
import {ProfileService} from "../../services/profile.service";
import {EmojiPillItem} from "./emoji-pill.types";

@Component({
  selector: 'app-emoji-pill-dialog',
  imports: [
    DialogModule,
    FormButtonComponent,
    HeadlineComponent,
    TooltipComponent,
    TranslatePipe,
    ContentComponent
  ],
  templateUrl: './emoji-pill-dialog.component.html',
  styleUrl: './emoji-pill-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmojiPillDialogComponent {
  public dialogService: DialogService = inject(DialogService);
  private profileService: ProfileService = inject(ProfileService);

  public emojis: InputSignal<EmojiPillItem[]> = input<EmojiPillItem[]>([]);
  public visible: InputSignal<boolean> = input<boolean>(true);
  public deleteEmoji: OutputEmitterRef<number> = output<number>();
  public closeRequest: OutputEmitterRef<void> = output<void>();
  public displayedEmojis: WritableSignal<EmojiPillItem[]> = signal<EmojiPillItem[]>([]);

  private emojisSyncEffect: EffectRef = effect(() => {
    this.displayedEmojis.set(this.emojis());
  });

  public sortedEmojis: Signal<EmojiPillItem[]> = computed(() => {
    const currentUserId = this.profileService.profile()?.user?.id;
    const reactions = [...this.displayedEmojis()].filter((x) => x.userName !== '');
    
    if (!currentUserId) {
      return reactions;
    }

    return reactions.sort((a, b) => {
      const aOwn = a.userId === currentUserId;
      const bOwn = b.userId === currentUserId;
      if (aOwn === bOwn) {
        return 0;
      }
      return aOwn ? -1 : 1;
    });
  });

  public closeDialog(): void {
    this.closeRequest.emit();
  }

  public isOwnReaction(reaction: EmojiPillItem): boolean {
    return reaction.userId === this.profileService.profile()?.user?.id;
  }

  public removeReaction(event: MouseEvent, referenceId: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.displayedEmojis.set(this.displayedEmojis().filter((reaction) => reaction.referenceId !== referenceId));
    this.deleteEmoji.emit(referenceId);
  }
}
